module.exports = __webpack_public_path__ + "static/media/bx-check-circle.65d48f1c.svg";